const Button = {
  root: {
    borderRadius: 4,
  },
}

export default Button
